// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Mb6","footer":"styles_footer__2qTqk"};